/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLinesDown(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M229.65674,141.65723l-96,96a8.00182,8.00182,0,0,1-11.31348,0l-96-96A8.0001,8.0001,0,0,1,32,128H72V104a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v24h40a8.0001,8.0001,0,0,1,5.65674,13.65723ZM184,40a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,40Zm0,32a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,72Z" />
    </Svg>
  );
}

export default ArrowFatLinesDown;
